import * as React from 'react';
import { Text, TextStyle, Inset, InsetSize } from '@doordash/design-language';
import { EntryContainer, CartCancelledText, HiddenPlaceholderForEmptyText, } from './GroupOrderEntryStyles';
import { CalendarStrings } from '../Calendar/CalendarStrings';
import StoreImageView from './StoreImageView';
var EntryViewCancelledOrder = function (_a) {
    var entry = _a.entry, _b = _a.debugMode, debugMode = _b === void 0 ? false : _b;
    var contentStrings = CalendarStrings.groupOrderEntry.cancelledOrder;
    return (React.createElement(EntryContainer, null,
        React.createElement(StoreImageView, { entry: entry }),
        React.createElement(Inset, { verticalSize: InsetSize.XSmall, horizontalSize: InsetSize.None },
            React.createElement(Text, { styles: TextStyle.Label2Emphasis }, entry.store.name),
            React.createElement(CartCancelledText, { children: contentStrings.cancelled() }),
            React.createElement(HiddenPlaceholderForEmptyText, null)),
        debugMode && React.createElement(Text, null, entry.targetDeliveryTime)));
};
export default EntryViewCancelledOrder;
